const SURVEY = "/survey";

export const ROUTES = {
  SURVEY,
};
